module.exports = __webpack_public_path__ + "0ce259acd0d5660b3eee2d3a2e2c7184-logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/assets/logo.png
// module id = 249
// module chunks = 0